import { Controller } from "@hotwired/stimulus"

// Pokazuje/ukrywa wiersz z telefonami w zależności od wybranego połączenia
export default class extends Controller {
  static targets = ["callSelect", "phoneRow"]

  togglePhoneRow() {
    if (!this.hasPhoneRowTarget) return

    if (this.callSelectTarget.value) {
      this.phoneRowTarget.classList.add("hidden")
    } else {
      this.phoneRowTarget.classList.remove("hidden")
    }
  }
}
